import React from "react";
import { DmsHelpCenterOverlay } from "./DmsHelpCenterOverlay";

export const DmsHelpCenter = (props) => {
  return <DmsHelpCenterOverlay {...props} />;
};

export { DmsHelpCenterContactTab } from "./DmsHelpCenterContactTab";